import { HttpHeaders, HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
// 2026/09/02 NS — single import path (relative); do not also import from @auth-suite-services/mbe-service (TS2300)
import { NamespaceTablesInterfaceAPI } from '../model/namespace-tables';
import { TableFieldsInterfaceAPI } from '../model/table-field';
import { Observable, catchError, map, throwError } from "rxjs";
import { mbeConfigService } from "./mbe-config.service";

@Injectable({
  providedIn: 'root'
})
export class HandleNamespaceSelectionsService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllTables(namespace: string): Observable<NamespaceTablesInterfaceAPI> {
    console.log('Namespace: ' + namespace);
    const headers = this.headers;
    return this.httpClient.get<NamespaceTablesInterfaceAPI>(`${this.URL}/hns/getalltables/${namespace}`, {headers}).pipe(
        catchError(this.handleError));
  }

  // 2026/09/02 NS previous signature (table only; TermMan Property dropdown empty)
  // getAllFields(table: string): Observable<TableFieldsInterfaceAPI> {
  //   console.log('Table: ' + table);
  //   const headers = this.headers;
  //   return this.httpClient.get<TableFieldsInterfaceAPI>(`${this.URL}/hns/getallfields/${table}`, {headers}).pipe(
  //       catchError(this.handleError));
  // }

  /// 2026/09/02 NS include namespace/schema so INFORMATION_SCHEMA filters TABLE_SCHEMA (TermMan etc.)
  getAllFields(namespace: string, table: string): Observable<TableFieldsInterfaceAPI> {
    console.log('Namespace: ' + namespace + ' Table: ' + table);
    const headers = this.headers;
    // 2026/09/02 NS encode path segments (spaces/newlines from UI must not break match)
    const ns = encodeURIComponent(namespace);
    const tbl = encodeURIComponent(table);
    return this.httpClient.get<any>(`${this.URL}/hns/getallfields/${ns}/${tbl}`, {headers}).pipe(
        // 2026/09/02 NS normalize total_count / items like other MBE list APIs
        map((res) => {
          const items = res?.items ?? [];
          const total_count = res?.total_count ?? res?.totalCount ?? items.length;
          return { items, total_count } as TableFieldsInterfaceAPI;
        }),
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}
